import React, { useEffect, useState } from 'react';
import useRequest from 'hooks/useRequest';
import { useAuth } from 'context/AuthContext';
import { useNavigation } from '../../context/NavigationContext';
import {
    BringzzIcon,
    BringzzText,
    BringzzModal,
    BringzzPageContainer
} from '@bringzz/components';
import { toast } from 'react-toastify';

const AddressPage = () => {
    const { user } = useAuth();
    const { sendRequest, loading } = useRequest();
    const [userAddress, setUserAddress] = useState([]);
    const [addressToDelete, setAddressToDelete] = useState(null);
    const [showOptionsId, setShowOptionsId] = useState(null);
    const { backPress, navigate } = useNavigation();
    const [modalOpen, setModalOpen] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);

    const fetchAddresses = async () => {
        if (!user || !user.integrationId) {
            console.log('User role not available');
            setUserAddress([]);
            return;
        }

        try {
            const response = await sendRequest({
                method: 'GET',
                url: '/module/address/getAddress',
            });

            if (response.status === 'success' && Array.isArray(response.data)) {
                setUserAddress(response.data);
            } else {
                setUserAddress([]);
                toast.error('Failed to load addresses');
            }
            console.log(user)
        } catch (error) {
            console.error('Request failed:', error);
            setUserAddress([]);
            toast.error('Failed to load addresses');
        }
    };

    useEffect(() => {
        if (user && user.integrationId) fetchAddresses();
    }, [user]);

    const handleDeleteAddress = async (integrationId) => {
        if (!integrationId) {
            console.log('No integrationId, returning');
            return;
        }

        try {
            setDeleteLoading(true);

            const response = await sendRequest({
                method: 'POST',
                url: '/module/address/deleteAddressByIntegrationId',
                data: {
                    integrationId: integrationId,
                }
            });

            if (response.status === 'success') {
                setUserAddress(userAddress.filter((address) => address.integrationId !== integrationId));
                setAddressToDelete(null);
                setModalOpen(false);
                toast.success('Address deleted successfully');
            } else {
                toast.error('Failed to delete the address');
            }
        } catch (error) {
            console.error('Request failed:', error);
            toast.error('Failed to delete the address');
        } finally {
            setDeleteLoading(false);
        }
    };

    const searchParams = new URLSearchParams(window.location.search);
    const isEdit = searchParams.has('edit');
    const isNew = searchParams.get('new') === 'true';

    useEffect(() => {
        if (isEdit) {
            const addressId = searchParams.get('edit');
        }
    }, [isEdit, searchParams]);

    return (
        <BringzzPageContainer
            header={{
                left: (
                    <BringzzIcon
                        size='22'
                        icon='IconChevronLeft'
                        folder='LineIcons'
                        className='cursor-pointer'
                        onClick={backPress}
                    />
                ),
                title: <BringzzText tag='h2'>{isNew ? 'Add New Address' : isEdit ? 'Edit Address' : 'Addresses'}</BringzzText>
            }}
            footer={
                !(user?.userRole === 1 && userAddress.length > 0) && (
                    <div className='pb-28 px-6'>
                        <button
                            className="w-full py-4 text-sm font-medium text-midnight-blue bg-magic-lilac rounded-full disabled:opacity-50"
                            onClick={() => {
                                navigate('/settings/account/address?new=true');
                                // toast.info('Adding new address...');
                            }}
                            disabled={loading}
                        >
                            <BringzzText
                                tag='h3'
                                className='text-normal whitespace-pre-line truncate'
                            >
                                Add new address
                            </BringzzText>
                        </button>
                    </div>
                )
            }
        >
            {loading ? (
                <div className="flex-grow flex items-center justify-center">
                    <BringzzIcon
                        size="32"
                        icon="IconSpinner"
                        folder="LineIcons"
                        className="animate-spin text-magic-lilac"
                    />
                </div>
            ) : (
                <div className="space-y-8 p-6">
                    {userAddress.length === 0 ? (
                        <div className="text-center py-8 text-gray-500">
                            <BringzzText tag='p'>No addresses found</BringzzText>
                        </div>
                    ) : (
                        userAddress.map((address) => (
                            <div key={address.id} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300">
                                <div className="flex items-center justify-between px-4 py-6 relative">
                                    <div className="flex items-center gap-4">
                                        <div>
                                            <BringzzIcon
                                                size='22'
                                                icon='IconMoshjidLocation'
                                                folder='LineIcons'
                                                className='cursor-pointer'
                                            />
                                        </div>
                                        <div>
                                            <p className="text-sm font-semibold text-[#1C1B1F]">
                                                {[
                                                    address.streetName,
                                                    address.houseNumber

                                                ].filter(Boolean).join(' ')}
                                            </p>
                                            <p className="text-base text-[#49454F]">
                                                {[address.postalCode, address.cityName].filter(Boolean).join(' ') +
                                                    (address.countryName ? ', ' + address.countryName : '')}
                                            </p>
                                        </div>
                                    </div>

                                    {!(user?.userRole === 1 && address.isOwner === false) && (
                                        <div className="flex items-center gap-2">
                                            {showOptionsId === address.id ? (
                                                <div className="flex rounded-lg overflow-hidden">
                                                    <div
                                                        className="flex items-center justify-center w-10 h-10 bg-[#F3E8FF] cursor-pointer"
                                                        onClick={() => {
                                                            navigate(`/settings/account/address?edit=${address.integrationId}`);
                                                            // toast.info('Editing address...');
                                                        }}
                                                    >
                                                        <BringzzIcon
                                                            size='22'
                                                            icon='IconPencilCopy'
                                                            folder='LineIcons'
                                                            className='cursor-pointer'
                                                        />
                                                    </div>

                                                    <div
                                                        className="flex items-center justify-center w-10 h-10 bg-[#EADDFF] cursor-pointer"
                                                        onClick={() => {
                                                            setAddressToDelete(address);
                                                            setModalOpen(true);
                                                        }}
                                                    >
                                                        <BringzzIcon
                                                            size='22'
                                                            icon='IconTrashCanCopy'
                                                            folder='LineIcons'
                                                            className='cursor-pointer'
                                                        />
                                                    </div>
                                                </div>
                                            ) : (
                                                <div
                                                    className="cursor-pointer"
                                                    onClick={() =>
                                                        setShowOptionsId(showOptionsId === address.id ? null : address.id)
                                                    }
                                                >
                                                    <BringzzIcon
                                                        size='22'
                                                        icon='IconPencilCopy'
                                                        folder='LineIcons'
                                                        className='cursor-pointer'
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))
                    )}
                </div>
            )}

            {modalOpen && (
                <div className="fixed inset-0 p-6 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg w-full max-w-sm shadow-lg">
                        <div className="p-8">
                            <h3 className="text-center font-semibold text-lg mb-2">Delete this address ?</h3>
                            <p className="text-center text-sm text-gray-600 mb-4">This address will be permanently deleted.</p>
                        </div>
                        <div className="w-full border-t border-gray-300">
                            <div className="flex justify-between">
                                <button
                                    className="w-full py-3 text-blue-500 text-center"
                                    onClick={() => setModalOpen(false)}
                                >
                                    Cancel
                                </button>
                                <div className='border-r border-gray-300'></div>
                                <button
                                    className="w-full py-3 text-blue-500 text-center"
                                    onClick={() => {
                                        console.log('Delete button clicked directly!');
                                        console.log('addressToDelete:', addressToDelete);
                                        handleDeleteAddress(addressToDelete?.integrationId);
                                    }}
                                    disabled={deleteLoading}
                                >
                                    {deleteLoading ? 'Deleting...' : 'Delete'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </BringzzPageContainer>
    );
};

export default AddressPage;
